module.exports = __webpack_public_path__ + "static/media/Group_1000006768.e95fa281.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_151/img/Group_1000006768.png
// module id = 1491
// module chunks = 0